var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line tw-mx-auto tw-my-[56px] tw-h-[2px] tw-w-full tw-bg-[#D7E3E3]"})
}
var staticRenderFns = []

export { render, staticRenderFns }